import React from 'react'

import question from '../../images/question.svg'
import questionInvert from '../../images/question_reverse.svg'

import styles from './help.module.scss'

export default function Help({ description }) {
  return (
    <section className={styles.help}>
      <img
        src={question}
        alt="Question Mark Icon"
        className={styles.helpIcon}
      />
      <img
        src={questionInvert}
        alt="Question Mark Icon"
        className={styles.helpIconInvert}
      />
      {description}
    </section>
  )
}
